<template>
  <div class="jijiagong-page">
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner workorder_banner">
			<div class="cover">
			</div>	
			<div class="cover-content">
				<div class="bodyinfo">			
					<h2 style="width: 408px;">智能工单ERP</h2>
					<p>生产、审批流程管理、生产工序、售后工单管理服务</p>
					<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
				</div>
			</div>	
		</div>
		<div class="workorder_nr bby_info" style="paddingTop: 0px;">
			<div class="bby_info_nr">
				<div class="workorder_nr1 workorder_nr_background">
					<div class="bby_info_content">
						<span class="span1">APPLICATION</span>
						<span class="span2">智能工单</span>
						<span class="span3">APP端</span>
						<span class="span4">我发起的、已处理、已完成的工单</span>
						<img class="img1" src="../../html/image/workorder/workorder_nr1_1.png" />
						<img class="img2" src="../../html/image/workorder/workorder_nr1_2.png" />
					</div>
				</div>
				<div class="workorder_nr2 workorder_nr_background">
					<div class="workorder_bg">
						
					</div>
					<div class="bby_info_content" style="textAlign: left;">
						<span class="span33">扫描枪</span>
						<span class="span44">扫描工牌、物料、维修产品二维码、RFID标签</span>
<!--						<span class="span1">扫描枪</span>
						<span class="span2"></span>-->
						<img class="img2" src="../../html/image/workorder/workorder_nr2_1.png" />
						<img class="img3" src="../../html/image/workorder/workorder_nr2_2.png" />
					</div>
				</div>
				<div class="workorder_nr3 workorder_nr_background">
					<div class="bby_info_content bg3-3">
						<span class="span1">PC端</span>
						<span class="span2">配置管理各类工单、新增工单字段、新增工单流转规则</span>
						<img class="img2" src="../../html/image/workorder/workorder_nr3_1.png" />
					</div>
				</div>
				<div class="workorder_nr4 workorder_nr_background" style="background: #fff;">
					<div class="bby_info_content">
						<span class="span1">IPAD端</span>
						<span class="span2">操作员、管理员移动看板、快速了解产量、库存、工单状态</span>
						<img class="img1" src="../../html/image/workorder/workorder_nr3_2.png" />
					</div>
				</div>
			</div>
		</div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'jijiagong',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  @import '../../html/css/zkm.css';
  @import '../../html/css/zkm.market.css';
</style>
